import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ActionButton from 'components/button/ActionButton';
import Dialog from 'components/ui/dialog/Dialog';
import EnhancedRaisedButton from 'components/button/EnhancedRaisedButton';
import RenderBooleanInputField from 'components/form/InputFields/RenderBooleanInputField';
import RenderPercentageInputField from 'components/form/InputFields/RenderPercentageInputField';
import RenderRadioButtonGroupField from 'components/form/InputFields/RenderRadioButtonGroupField';
import { AlertIcon, PaymentIcon } from 'assets/materialIcons/materialIcons';
import { Field, reduxForm } from 'redux-form';
import { FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { compose } from 'recompose';
import authHelper from 'helpers/auth';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import validations from 'helpers/forms/validations';

class BookingRefund extends Component {
    state = {
        showDialog: false,
    };

    componentDidMount() {
        this.initializeForm();
    }

    initializeForm = () => {
        const { booking, initialize } = this.props;

        const isAdmin = authHelper.isAdmin();
        const initialValues = {
            refund_to_wallet: false,
        };

        if (isAdmin) {
            initialValues.refund_administration_fee = false;
            initialValues.refund_insurance_fee = false;
            initialValues.refund_percentage = booking.costfree_cancellation ? 100 : 85;
        }

        initialize(initialValues);
    }

    toggleDialog = () => {
        this.setState((state) => {
            return {
                showDialog: !state.showDialog,
            };
        }, () => {
            if (!this.state.showDialog) {
                this.initializeForm();
            }
        });
    }

    render() {
        const {
            booking,
            handleSubmit,
            invalid,
            submitting,
            translate,
            refund,
        } = this.props;

        const actions = [
            <EnhancedRaisedButton
                key='cancel'
                keyboardFocused={ true }
                label={ translate('actions.goBack') }
                onTouchTap={ this.toggleDialog }
                style={ { marginRight: '20px' } }
            />,
            <EnhancedRaisedButton
                backgroundColor={ theme.palette.redOrange }
                icon={ <AlertIcon /> }
                key='submit'
                label={ translate('actions.refund') }
                labelColor={ theme.palette.white }
                disabled={ submitting || invalid }
                loading={ submitting }
                onClick={ handleSubmit(refund) }
                type='submit'
            />,
        ];

        const isAdmin = authHelper.isAdmin();
        const isProvider = authHelper.isProvider();
        const isReseller = authHelper.isReseller(); // TODO remove when resellers can set refund_to_wallet

        const refundPercentageOptions = [
            {
                label: translate('fields.full'),
                value: 100,
            },
        ];

        if (!booking.costfree_cancellation) {
            refundPercentageOptions.unshift({
                label: translate('export.field_groups.default'),
                value: 85,
            });
        }

        return (
            <div>
                <ActionButton
                    icon={ <PaymentIcon color={ theme.palette.doveGray } /> }
                    onClick={ () => {
                        // TODO remove when resellers can set refund_to_wallet
                        if (isReseller || isProvider) {
                            return refund(); // Refunds with false refund_to_wallet
                        }

                        return this.toggleDialog();
                    } }
                    title={ translate('actions.refund') }
                />

                <Dialog
                    actions={ actions }
                    actionsContainerStyle={ { padding: '0 24px 24px' } }
                    contentStyle={ { maxWidth: '400px' } }
                    overlayStyle={ {
                        backgroundColor: 'rgba(237, 236, 236, 0.6)',
                    } }
                    onRequestClose={ this.toggleDialog }
                    open={ this.state.showDialog }
                    title={ translate('resources.bookings.refund') }
                >
                    <FormWrapper>
                        <form>
                            <Section>
                                { /*  TODO return to wallet field */ }

                                { isAdmin && (
                                    <Row>
                                        <Item>
                                            <Field
                                                component={ RenderRadioButtonGroupField }
                                                options={ refundPercentageOptions }
                                                label={ 'refund_percentage' }
                                                name='refund_percentage'
                                                otherComponent={ RenderPercentageInputField }
                                                validate={ [
                                                    validations.number,
                                                    validations.required,
                                                ] }
                                            />
                                        </Item>
                                    </Row>
                                ) }
                            </Section>

                            { isAdmin && (
                                <Section title={ translate('resources.bookings.forms.additional') }>
                                    <Row>
                                        <Item>
                                            <Field
                                                component={ RenderBooleanInputField }
                                                label={ translate('export.fields.administration_fee') }
                                                name='refund_administration_fee'
                                            />
                                        </Item>
                                    </Row>
                                    <Row>
                                        <Item>
                                            <Field
                                                component={ RenderBooleanInputField }
                                                label={ translate('export.fields.costfree_cancellation') }
                                                name='refund_insurance_fee'
                                            />
                                        </Item>
                                    </Row>
                                </Section>
                            ) }
                        </form>
                    </FormWrapper>
                </Dialog>
            </div>
        );
    }
}

BookingRefund.propTypes = {
    booking: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    refund: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const enhance = compose(
    translate,
    reduxForm({
        form: 'booking-refund',
    })
);

export default enhance(BookingRefund);



// WEBPACK FOOTER //
// ./src/pages/bookings/show/actions/refund/BookingRefund.js